import React from 'react';
import {
  Droppable,
} from 'react-beautiful-dnd';

import {
  Icon,
  ExercisePropertyLabel,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import Property from './Property';
import * as S from './styled';

type Props = {
  readOnly: boolean,
  exerciseId: number,
  properties: any[],

  onRequestSave: { (): void },
  onRequestDelete: { (): void },
};

const ExerciseProperties = ({
  readOnly,
  exerciseId,
  properties,
  onRequestSave,
  onRequestDelete,
}: Props) => {
  if (!properties.length && !readOnly) {
    return (
      <Text noPrint color="#d0cfd0">
        Add metrics (such as sets, reps, etc) you would like to track
        about your client by selecting the + icon.
      </Text>
    );
  }
  return readOnly
    ? (
      <Flex
        wrap="wrap"
        spacing={10}
      >
        {properties.map(property => (
          <S.Label key={property.id} readOnly>
            <Icon
              type="fas fa-bars"
              size="11px"
            />
            <ExercisePropertyLabel property={property} />
          </S.Label>
        ))}
      </Flex>
    ) : (
      <Droppable
        type="property"
        direction="horizontal"
        droppableId={exerciseId.toString()}
      >
        {droppableProvided => (
          <Flex
            ref={droppableProvided.innerRef}
            wrap="wrap"
          >
            {properties.map((property, index) => (
              <Property
                key={property.id}
                index={index}
                property={property}
                exerciseId={exerciseId}
                onRequestSave={onRequestSave}
                onRequestDelete={onRequestDelete}
              />
            ))}
            {droppableProvided.placeholder}
          </Flex>
        )}
      </Droppable>
    );
};

export default ExerciseProperties;
